import React, { useCallback, useContext } from 'react';
import get from 'lodash/get';
import map from 'lodash/map';
import set from 'lodash/set';

import {
  ContainerForOptions,
  OptionContainer,
  Row,
  StyledTextarea,
} from 'src/presentation/components/pages/ivr/layouts/IvrLayout';
import InputField from 'src/presentation/components/forms/InputField';
import useOptionsGeneratedIds from 'src/presentation/components/pages/ivr/hooks/useOptionsGeneratedIds';

import FormContext from 'src/presentation/contexts/FormContext';

const HEADER_TEMPLATES_ATTR = 'headerTemplates';

const Http2NodeHeaders = ({ attr, disabled, readOnly }) => {
  const { updateState, workingState } = useContext(FormContext);

  const headers = get(workingState, `${attr}.${HEADER_TEMPLATES_ATTR}`, []);

  const { addOptionId, optionsIds, removeOptionIdByIndex } = useOptionsGeneratedIds(headers);

  const onAddButtonClick = useCallback(() => {
    const withNewMenuItem = [
      ...headers,
      {
        name: '',
        valueTemplate: '',
      },
    ];
    updateState(set({}, `${attr}.${HEADER_TEMPLATES_ATTR}`, withNewMenuItem));
    addOptionId();
  }, [attr, headers, updateState, addOptionId]);

  return (
    <ContainerForOptions
      addButtonLabel="Add Header"
      onAddButtonClick={onAddButtonClick}
      description="The specific header information that accompanies API requests and responses"
      disabled={disabled || readOnly}
      label="Headers"
      context={map(headers, (_, idx) => {
        return (
          <HeaderValue
            attr={attr}
            index={idx}
            key={optionsIds[idx] || idx}
            disabled={disabled}
            readOnly={readOnly}
            removeOptionIdByIndex={removeOptionIdByIndex}
          />
        );
      })}
    ></ContainerForOptions>
  );
};

const HeaderValue = ({ attr, index, disabled, readOnly, removeOptionIdByIndex }) => {
  const baseAttr = `${attr}.${HEADER_TEMPLATES_ATTR}[${index}]`;
  const baseDataAid = `${HEADER_TEMPLATES_ATTR}[${index}]`;
  return (
    <OptionContainer
      attrList={`${attr}.${HEADER_TEMPLATES_ATTR}`}
      currentIndex={index}
      removeOptionIdByIndex={removeOptionIdByIndex}
      data-aid={baseDataAid}
      disabled={disabled}
      readOnly={readOnly}
    >
      <Row>
        <InputField
          attr={`${baseAttr}.name`}
          data-aid={`${baseDataAid}.name`}
          description="The name of the header for the HTTP request"
          disabled={disabled}
          label="Name"
          readOnly={readOnly}
        />
      </Row>

      <Row>
        <StyledTextarea
          attr={`${baseAttr}.valueTemplate`}
          data-aid={`${baseDataAid}.valueTemplate`}
          description="The value associated with the header name"
          disabled={disabled}
          label="Value"
          readOnly={readOnly}
        />
      </Row>
    </OptionContainer>
  );
};

export default Http2NodeHeaders;
